import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Filters from 'components/Filters/Filters'
import { selectBusinessTypes } from 'store/businesses'
import { optionsMessages, subjectsMessages } from './messages'
import { InjectedIntlProps, injectIntl } from 'react-intl'
import { businessesFilterGroups, BusinessUsableFilters } from '../../utils/filters'

interface BusinessesFiltersProps {
  filters: BusinessUsableFilters
  onChange: () => void
  onClose: () => void
  className: string
}

const BusinessesFilters: React.FC<BusinessesFiltersProps & InjectedIntlProps> = ({
  filters,
  onChange,
  onClose,
  className,
  intl,
}) => {
  const businessTypes = useSelector(selectBusinessTypes)
  const [initialValues, setInitialValues] = useState({})

  return (
    <Filters
      groups={businessesFilterGroups}
      filters={filters}
      onChange={onChange}
      onClose={onClose}
      businessTypes={businessTypes}
      renderSubject={(subject: string) =>
        intl.formatMessage(subjectsMessages[subject as keyof typeof subjectsMessages])
      }
      renderOption={(option: string) =>
        optionsMessages[option as keyof typeof optionsMessages]
          ? intl.formatMessage(optionsMessages[option as keyof typeof optionsMessages])
          : option
      }
      className={className}
      initialValues={initialValues}
    />
  )
}

export default injectIntl(BusinessesFilters)
